import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF !important",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    // Clip horizontal overflow but let the search dropdown extend downward.
    overflowX: "clip",
    overflowY: "visible",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    padding: "8px 24px",
    maxWidth: "100%",
    width: "100%",
    minHeight: "64px !important",
    boxSizing: "border-box",
    overflowX: "clip",
    overflowY: "visible",
    [theme.breakpoints.down("md")]: {
      padding: "8px 16px",
    },
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  centerSection: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    padding: "0 16px",
    minWidth: 0,
    // Allow the search dropdown to overflow downward (clip only horizontally).
    overflowX: "clip",
    overflowY: "visible",
    [theme.breakpoints.down("lg")]: {
      padding: "0 12px",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  flex: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  font700: {
    fontWeight: 700,
  },
  ml: {
    marginLeft: "8px",
  },
  brandName: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: "#FF3008",
    marginLeft: 8,
    letterSpacing: "-0.02em",
  },
  userButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: 24,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },
  menu: {
    marginTop: theme.spacing(3),
  },
  menuItem: {
    padding: "12px 20px",
    width: "100%",
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: "#F7F7F7",
    },
  },
  menuPaper: {
    borderRadius: 12,
    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
    marginTop: 8,
    minWidth: 180,
  },
  linkDecoration: {
    textDecoration: "none",
    alignSelf: "center",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  cartButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    borderRadius: 24,
    backgroundColor: "#CC0000",
    color: "#FFFFFF",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#AA0000",
      transform: "scale(1.02)",
    },
  },
  cartText: {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: "#FFFFFF",
  },
  iconButton: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },
  icon: {
    color: "#191919",
    width: 22,
    height: 22,
  },
  iconActive: {
    color: "#CC0000",
  },
  divider: {
    height: 24,
    margin: "0 8px",
    backgroundColor: "rgba(0,0,0,0.08)",
  },
  userName: {
    fontWeight: 500,
    color: "#191919",
    maxWidth: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  searchContainer: {
    flex: 1,
    maxWidth: 500,
    margin: "0 24px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  searchInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 24,
      backgroundColor: "#F5F5F5",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#EEEEEE",
      },
      "&.Mui-focused": {
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      },
      "& fieldset": {
        border: "none",
      },
    },
    "& input": {
      padding: "12px 16px",
      fontSize: "0.875rem",
    },
  },
}));

export default useStyles;
